import "./Form.scss";
import { useEffect, useState } from "react";
import { withRouter } from "../../../helpers/withRouter";
import { useTranslation } from "react-i18next";
import { Spin, Form as FormAnt } from "antd";
import i18nextConfig from "../../../config/i18next";

import { FormDeclaration } from '../'
import { getFormByIdPromise } from "../components/FormDetail/promises";
import { getParamsUboFinderPromise, saveFormPromise } from "../../InterestConflicts/promises";

const Form = ({ match, form }) => {
    const { t, i18n } = useTranslation("forms");
    const [isLoading, setIsloading] = useState(true);
    const [mode, setMode] = useState("html");
    const [frm, setFrm] = useState(null);
    const [apiForm, setApiForm] = useState(null);
    const [hasSign, setHasSign] = useState(false);

    useEffect(async () => {
        document.body.id = 'form-layout'
        if(match.params.id) {
            loadForm(match.params.id)
            if (match.params.view === "pdf") {
                setMode("pdf");
            }
        }
    }, [])

    const loadForm = (id) => {
        setIsloading(true);
        getFormByIdPromise(id).then(response => {
            setApiForm(response)
            let json = response.json??{}
            const sections = (json.sections??[]).filter(s => s.status === "ACTIVE")
            json.sections = sections
            
            let language
            if(match.params.view === "pdf") {
              language = json.language??i18n.language;
              i18nextConfig.changeLanguage(language)
            }else {
              language = i18n.language;
              if(json.language !== language) {
                response.json.language = language
                saveFormPromise(response)
              }
            }
            let lang = "all"
            if(json.languages?.length > 0) {
                const language1 = language.substring(0, 2)
                if(json.languages.includes(language1)) {
                    lang = language1
                }else {
                    lang = json.languages[0]
                }
            }

            if(json.hasSign) {
                const clientId = response.recipient.request.clientId
                getParamsUboFinderPromise(clientId).then((response) => {
                    setHasSign(response.data.firma !== "N");
                });
            }

            const form = {id: response.id, folio: response.folio, formParentId: response.recipient.formTemplateId,...json, lang}
            setFrm(form)
            setIsloading(false);
        })
    }

    return (
        <div className={"form-manager-formulario" + (' mode-'+mode)}>
            {isLoading ? <Spin />
                :
                <FormDeclaration client={apiForm.recipient.request?.createUser?.cliente} apiForm={apiForm} form={frm} mode={mode} lang={frm.lang} hasSign={hasSign} />
            }
        </div>
    )
}
export default FormAnt.create()(withRouter(Form));
